import React, { useCallback, useLayoutEffect } from 'react';
import { useAsyncValue, useNavigate, useRevalidator } from 'react-router-dom';

// Components
import { ShowOT } from '../../../../components/display/ShowOT/';

// Types
import { OrderDataTypes } from '../../../../components/display/ShowOT/types';
import { useRevalidateOnSync } from '../../../../offline/useRevalidateOnSync';
import { useDispatch } from 'react-redux';
import { roidOTSelected } from '../../../../state/actions/ui/roidOTSelectedGeneralView';
import { OrderType } from '../../../../types/orders';

export default function WorkOrderDetailed(): JSX.Element {
  const workOrderData = useAsyncValue() as OrderDataTypes[];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const revalidator = useRevalidator();
  useRevalidateOnSync();

  useLayoutEffect(() => {
    if (!workOrderData || workOrderData.length === 0) {
      navigate('/work-orders');
      return;
    }
    dispatch(
      roidOTSelected(
        workOrderData[0].type === OrderType.Campaign
          ? OrderType.Campaign
          : OrderType.Generic,
        Array.isArray(workOrderData[0].roid)
          ? workOrderData[0].roid.join('.')
          : workOrderData[0].roid,
        workOrderData[0].id
      )
    );
  }, [workOrderData]);

  const onRefetchData = useCallback(() => {
    revalidator.revalidate();
  }, []);

  if (!workOrderData || !Array.isArray(workOrderData) || workOrderData.length === 0) {
    return <></>;
  }

  return (
    <ShowOT
      data={workOrderData}
      revalidatorFunction={onRefetchData}
      restoreChildCardAnchor
    />
  );
}
